<template>
  <div class="select-all">
    <w-dropdown @command="handleCommand" trigger="click" placement="bottom-start" size="mini">
      <label class="w__checkbox" style="margin-right: 0;" :class="{'is-checked': checked}">
        <span aria-checked="mixed" class="w__checkbox__input" :class="{'is-checked': checked}">
          <span class="w__checkbox__inner"></span>
          <input type="checkbox" aria-hidden="true" class="w__checkbox__original" value="">
        </span>
        <span class="w__checkbox__label"><i class="w-icon-xiala"></i></span>
      </label>
      <w-dropdown-menu slot="dropdown">
        <w-dropdown-item command="current">
          <div class="font-12" :class="selected === 'current' ? 'color-blue' : ''">
            <i class="w-icon-tijiao" style="font-size: 12px;"></i>
            全选当前页所有数据
          </div>
        </w-dropdown-item>
        <w-dropdown-item command="all">
          <div class="font-12" :class="selected === 'all' ? 'color-blue' : ''">
            <i class="w-icon-tijiao" style="font-size: 12px;"></i>
            全选所有页(共<span>{{pageTotal}}</span>页)数据
          </div>
        </w-dropdown-item>
      </w-dropdown-menu>
    </w-dropdown>
  </div>
</template>
<script>
import {on, off} from '@/assets/utils'
export default {
  name: 'SelectAll',
  props: {
    resetSelectAll: {
      type: Number,
      default: 0
    },
    currentPageItemCount: { // 当前页 总的 数据条数
      type: Number,
      default: 0,
      required: true
    },
    currentPageItemSelected: { // 当前页 已选择 数据条数
      type: Number,
      default: 0,
      required: true
    },
    pageTotal: { // 总页码
      type: Number,
      default: 0
    },
    top: { // 下拉框位置 上下偏移
      type: Number,
      default: 20
    },
    left: { // 下拉框位置 左右偏移
      type: Number,
      default: -33
    }
  },
  data () {
    return {
      selected: ''
    }
  },
  computed: {
    lineStyle () {
      let sty = 'top: ' + this.top + 'px;' + 'left: ' + this.left + 'px;'
      return sty
    },
    checked () {
      let checked = false
      if (this.selected === 'all') {
        checked = true
      } else if (this.selected === 'current' && this.currentPageItemSelected === this.currentPageItemCount){
        checked = true
      }
      return checked
    }
  },
  methods: {
    handleCommand (command) {
      this.select(command)
    },
    select (type) {
      if (this.selected === type) {
        this.selected = ''
      } else {
        this.selected = type
      }
      this.$emit('change', type, !!this.selected)
    }
  },
  watch: {
    'currentPageItemSelected': function () {
      const currentAllChecked = this.currentPageItemSelected === this.currentPageItemCount
      if (this.selected === 'current' && !currentAllChecked) {
        this.selected = ''
      } else if (this.selected === '' && currentAllChecked) {
        this.selected = 'current'
      }
    },
    'resetSelectAll': function () {
      this.selected = ''
    }
  }
}
</script>
<style lang="less" type="text/less">
  .select-all{
    display: inline-block;
    position: relative;
    i{
      font-size: 12px;
    }
    p{
      display: inline-block;
      white-space: nowrap;
      cursor: pointer;
    }
    .option_cont{
      border: 1px solid #d9d9d9;
      position: absolute;
      z-index: 10;
      background-color: #fff;
      font-weight: 500;
      a{
        display: block;
        text-align: left;
        padding: 4px;
        padding-right: 20px;
        padding-left: 8px;
        color: #333;
        white-space: nowrap;
        font-size: 12px;
        .w-icon-tijiao{
          margin-right: 10px;
          font-size: 12px;
          color: #eee;
          display: inline-block;
        }
        &:hover, &.active{
          background-color: rgba(243,244,247,1);
          color: #2079FA;
          .w-icon-tijiao{
            color: #2079FA;
          }
        }
      }
    }
  }
</style>
